import { Row } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";

import i18n from "i18next";
import {
  FooterSection,
  Title,
  NavLink,
  LogoContainer,
  Large,
  LargeInline,
  LanguageSwitch,
  LanguageSwitchContainer,
  FooterCol,
} from "./styles";
import { PngIcon } from "../../common/PngIcon";
import scrollTo from "../../common/utils/scrollIntoView";
import PrivacyPolicyModal from "../PrivacyPolicyModal";
import TermsOfServiceModal from "../TermsOfServiceModal";

interface SocialLinkProps {
  href: string;
  src: string;
  title: string;
}

const Footer = ({ t }: { t: TFunction }) => {
  const handleChange = (language: string) => {
    i18n.changeLanguage(language);
  };

  const SocialLink = ({ href, src, title }: SocialLinkProps) => {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={src}
        aria-label={src}
      >
        <SvgIcon src={src} width="25px" height="25px" />
        <LargeInline style={{ marginLeft: 5 }}>{title}</LargeInline>
      </a>
    );
  };

  return (
    <FooterSection>
      <Container>
        <Row justify="space-between">
          <FooterCol lg={8} md={8} sm={12} xs={24}>
            <div>
              <NavLink to="/">
                <LogoContainer>
                  <PngIcon
                    src="logo-full.png"
                    aria-label="homepage"
                    width="150px"
                    height="auto"
                  />
                </LogoContainer>
              </NavLink>
            </div>
            <div style={{ padding: '0 2rem 0 0'}}>
              {t('HeroSubTitle')}
            </div>
          </FooterCol>
          <FooterCol lg={4} md={4} sm={12} xs={24}>
            <Title>{t("Navigation")}</Title>
            <Large onClick={() => scrollTo("reviews")}>{t("Reviews")}</Large>
            <Large onClick={() => scrollTo("feedback")}>{t("PrivateFeedback")}</Large>
            <Large onClick={() => scrollTo("focus")}>{t("Focus")}</Large>
            <Large onClick={() => scrollTo("videos")}>{t("Videos")}</Large>
            <Large onClick={() => scrollTo("about")}>{t("About")}</Large>
          </FooterCol>
          <FooterCol lg={4} md={4} sm={12} xs={24}>
            <Title>{t("Connect")}</Title>
            <Large>
              <SocialLink
                href="https://www.youtube.com/@hidden.tenths"
                src="youtube.svg"
                title={t("YouTube")}
              />
            </Large>
          </FooterCol>
          <FooterCol lg={4} md={4} sm={12} xs={24}>
            <Title>{t("Legal")}</Title>
            <PrivacyPolicyModal />
            <TermsOfServiceModal />
          </FooterCol>
          <FooterCol lg={4} md={4} sm={12} xs={12}>
            <Title>{t("Language")}</Title>
            <LanguageSwitchContainer>
              <LanguageSwitch onClick={() => handleChange("en")}>
                <SvgIcon
                  src="united-states.svg"
                  aria-label="homepage"
                  width="30px"
                  height="30px"
                />
              </LanguageSwitch>
              <LanguageSwitch onClick={() => handleChange("bg")}>
                <SvgIcon
                  src="bulgaria.svg"
                  aria-label="homepage"
                  width="30px"
                  height="30px"
                />
              </LanguageSwitch>
            </LanguageSwitchContainer>
          </FooterCol>
        </Row>
        <Row justify="center" style={{ marginTop: '0.5rem' }}>
          <p style={{ fontSize: '1rem' }}>{t("AiAssistedArtworkDisclaimer")}</p>
        </Row>
      </Container>
    </FooterSection>
  );
};

export default withTranslation()(Footer);
